import React from "react";

type CropRotateProps = {
  color?: string;
};

const CropRotate: React.FC<CropRotateProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_16505_16649)">
        <path
          d="M5.48 14.3267C3.3 13.2867 1.74 11.1733 1.5 8.66667H0.5C0.84 12.7733 4.27333 16 8.46667 16C8.62 16 8.76 15.9867 8.90667 15.98L6.36667 13.4333L5.48 14.3267ZM8.53333 0C8.38 0 8.24 0.0133333 8.09333 0.0266667L10.6333 2.56667L11.52 1.68C13.7 2.71333 15.26 4.82667 15.5 7.33333H16.5C16.16 3.22667 12.7267 0 8.53333 0ZM11.1667 9.33333H12.5V5.33333C12.5 4.59333 11.9 4 11.1667 4H7.16667V5.33333H11.1667V9.33333ZM5.83333 10.6667V2.66667H4.5V4H3.16667V5.33333H4.5V10.6667C4.5 11.4 5.09333 12 5.83333 12H11.1667V13.3333H12.5V12H13.8333V10.6667H5.83333Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_16505_16649">
          <rect
            width="16"
            height="16"
            fill={color}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CropRotate;
